var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewConstruction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9H20.5L10.5 0L0.5 9H3.5V12H1.5V14H3.5V17H5.5V14H9.5V17H11.5V14H15.5V17H17.5V14H19.5V12H17.5V9ZM5.5 12V7.19L9.5 3.59V12H5.5ZM11.5 12V3.59L15.5 7.19V12H11.5Z",
    fill: "#C9D1CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9H20.5L10.5 0L0.5 9H3.5V12H1.5V14H3.5V17H5.5V14H9.5V17H11.5V14H15.5V17H17.5V14H19.5V12H17.5V9ZM5.5 12V7.19L9.5 3.59V12H5.5ZM11.5 12V3.59L15.5 7.19V12H11.5Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewConstruction);
export default __webpack_public_path__ + "static/media/NewConstruction.98fc4834c4f0f22fed3f92ee2d5d5e28.svg";
export { ForwardRef as ReactComponent };